<template>
        <div class="slides-container" :class="{ 'guide-highlight': highlight }">
                <!-- Контекстное меню -->
                <div v-if="showContextMenu" class="context-menu" :style="contextMenuStyle()">
                        <div class="context-menu__item">
                                <button class="context-menu__button" type="button" @click="handleDeleteSlide($event)">{{ $t('common.delete') }}</button>
                        </div>
                </div>
                <!-- Мобильная версия (только активный слайд) -->
                <div class="mobile-slide" v-if="isMobile">
                        <div class="mobile-slide-content">
                                <!-- Стрелка назад слева -->
                                <div class="mobile-nav-arrow">
                                        <router-link to="/projects">
                                                <img src="@/assets/images/content/arrow-left.svg" alt="Back" class="nav-arrow-icon">
                                        </router-link>
                                </div>

                                <!-- Кнопка Undo -->
                                <button 
                                        class="mobile-history-btn" 
                                        :class="{ disabled: !canUndo }" 
                                        @click="handleMobileUndo"
                                        :disabled="!canUndo"
                                        :title="$t('legacy.Отменить')"
                                >
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M19 13C19 11.3431 17.6569 9.99999 16 9.99999H7.41406L8.70703 11.293C9.09756 11.6835 9.09756 12.3165 8.70703 12.707C8.31651 13.0975 7.68349 13.0975 7.29297 12.707L4.29297 9.70702C3.90244 9.31649 3.90244 8.68348 4.29297 8.29295L7.29297 5.29295C7.68349 4.90243 8.31651 4.90243 8.70703 5.29295C9.09756 5.68348 9.09756 6.31649 8.70703 6.70702L7.41406 7.99999H16C18.7614 7.99999 21 10.2386 21 13C21 15.7614 18.7614 18 16 18H5C4.44772 18 4 17.5523 4 17C4 16.4477 4.44772 16 5 16H16C17.6569 16 19 14.6568 19 13Z" fill="currentColor"/>
                                        </svg>
                                </button>

                                <!-- Кнопка Redo -->
                                <button 
                                        class="mobile-history-btn" 
                                        :class="{ disabled: !canRedo }" 
                                        @click="handleMobileRedo"
                                        :disabled="!canRedo"
                                        :title="$t('editor.redo')"
                                >
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M5 13C5 11.3431 6.34315 9.99999 8 9.99999H16.5859L15.293 11.293C14.9024 11.6835 14.9024 12.3165 15.293 12.707C15.6835 13.0975 16.3165 13.0975 16.707 12.707L19.707 9.70702C20.0976 9.31649 20.0976 8.68348 19.707 8.29295L16.707 5.29295C16.3165 4.90243 15.6835 4.90243 15.293 5.29295C14.9024 5.68348 14.9024 6.31649 15.293 6.70702L16.5859 7.99999H8C5.23858 7.99999 3 10.2386 3 13C3 15.7614 5.23858 18 8 18H19C19.5523 18 20 17.5523 20 17C20 16.4477 19.5523 16 19 16H8C6.34315 16 5 14.6568 5 13Z" fill="currentColor"/>
                                        </svg>
                                </button>

                                <!-- Иконка выбора зоны (заменяет текст названия) -->
                                <button class="mobile-zone-selector" @click="toggleDropdown" @touchstart="handleTouchStart" @touchend="handleTouchEnd" :title="$t('editor.chooseZone')">
                                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="3" y="3" width="7" height="7" rx="1" stroke="currentColor" stroke-width="2"/>
                                                <rect x="14" y="3" width="7" height="7" rx="1" stroke="currentColor" stroke-width="2"/>
                                                <rect x="3" y="14" width="7" height="7" rx="1" stroke="currentColor" stroke-width="2"/>
                                                <rect x="14" y="14" width="7" height="7" rx="1" stroke="currentColor" stroke-width="2"/>
                                        </svg>
                                </button>

                                <!-- Кнопка слоёв -->
                                <button 
                                        class="mobile-layers-btn" 
                                        :class="{ active: layersPanelOpen }" 
                                        @click="handleToggleLayers" 
                                        :title="$t('legacy.Слои')"
                                >
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M2 17L12 22L22 17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M2 12L12 17L22 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                </button>

                                <!-- Кнопка калькулятора (только для Premium) -->
                                <button 
                                        v-if="canUseCalculator"
                                        class="mobile-calculator-btn" 
                                        @click="handleOpenCalculator" 
                                        :title="$t('legacy.Калькулятор')"
                                >
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                                <rect x="4" y="2" width="16" height="20" rx="2" stroke="currentColor" stroke-width="2"/>
                                                <line x1="8" y1="6" x2="16" y2="6" stroke="currentColor" stroke-width="2"/>
                                                <circle cx="8" cy="11" r="1" fill="currentColor"/>
                                                <circle cx="12" cy="11" r="1" fill="currentColor"/>
                                                <circle cx="16" cy="11" r="1" fill="currentColor"/>
                                                <circle cx="8" cy="15" r="1" fill="currentColor"/>
                                                <circle cx="12" cy="15" r="1" fill="currentColor"/>
                                                <circle cx="16" cy="15" r="1" fill="currentColor"/>
                                        </svg>
                                </button>

                                <!-- Три точки справа -->
                                <div class="mobile-menu-dots" @click.stop="toggleActionsMenu">
                                        <div class="menu-dots">
                                                <span></span>
                                                <span></span>
                                                <span></span>
                                        </div>
                                </div>
                        </div>

                        <!-- Выпадающее меню действий (телепортируется в body для корректного z-index) -->
                        <Teleport to="body">
                                <div class="actions-menu-wrapper" v-if="actionsMenuOpen" @click="closeActionsMenu">
                                        <div class="actions-menu-content" @click.stop>
                                                <div class="actions-menu-item" @click="handleToggleSelection">
                                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                        </svg>
                                                        <span>{{ $t('legacy.Группировка') }}</span>
                                                </div>
                                                <div class="actions-menu-item" @click="handleOpenBackground">
                                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" stroke-width="2"/>
                                                                <circle cx="8.5" cy="8.5" r="1.5" fill="currentColor"/>
                                                                <path d="M21 15L16 10L5 21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                        </svg>
                                                        <span>{{ $t('legacy.Фон') }}</span>
                                                </div>
                                                <div class="actions-menu-item" @click="handleOpenLayers">
                                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                                <path d="M2 17L12 22L22 17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                                <path d="M2 12L12 17L22 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                        </svg>
                                                        <span>{{ $t('legacy.Слои') }}</span>
                                                </div>
                                                <div class="actions-menu-divider"></div>
                                                <div class="actions-menu-item" @click="handleOpenSave">
                                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3H16L21 8V19C21 20.1046 20.1046 21 19 21Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                                <path d="M17 21V13H7V21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                                <path d="M7 3V8H15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                        </svg>
                                                        <span>{{ $t('common.save') }}</span>
                                                </div>
                                                <div class="actions-menu-item download-item" @click="handleDownloadImage">
                                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                                <path d="M7 10L12 15L17 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                                <path d="M12 15V3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                        </svg>
                                                        <span>{{ $t('common.download') }}</span>
                                                </div>
                                                <div class="actions-menu-divider"></div>
                                                <div class="actions-menu-item delete-item" @click="handleClearAll">
                                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M20 20H7L3 16C2.4 15.4 2.4 14.6 3 14L13 4C13.6 3.4 14.4 3.4 15 4L21 10C21.6 10.6 21.6 11.4 21 12L12 21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                                <path d="M6 11L13 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                                <path d="M18 21H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                        </svg>
                                                        <span>{{ $t('legacy.Очистить всё') }}</span>
                                                </div>
                                                <div class="actions-menu-item delete-item" @click="handleDeleteZone">
                                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M3 6H5H21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                                <path d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                                <line x1="10" y1="11" x2="10" y2="17" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                                                                <line x1="14" y1="11" x2="14" y2="17" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                                                        </svg>
                                                        <span>{{ $t('legacy.Удалить зону') }}</span>
                                                </div>
                                                <div class="actions-menu-divider"></div>
                                                                <div 
                                                                        class="actions-menu-item" 
                                                                        :class="{ 'locked': !canExportPdf }"
                                                                        @click="handleExportPDF"
                                                                        :title="!canExportPdf ? $t('legacy.Доступно для премиум подписки') : ''"
                                                                >
                                                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                                                <path d="M14 2V8H20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                                                <text x="7" y="17" font-size="6" fill="currentColor" font-weight="bold">PDF</text>
                                                                        </svg>
                                                                         <span>{{ $t('legacy.Смета PDF') }}</span>
                                                                        <svg v-if="!canExportPdf" class="lock-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <rect x="3" y="11" width="18" height="11" rx="2" stroke="currentColor" stroke-width="2"/>
                                                                                <path d="M7 11V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V11" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                                                                        </svg>
                                                                </div>
                                                                <div 
                                                                        class="actions-menu-item" 
                                                                        :class="{ 'locked': !canExportExcel }"
                                                                        @click="handleExportExcel"
                                                                         :title="!canExportExcel ? $t('legacy.Доступно для премиум подписки') : ''"
                                                                >
                                                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                                                <path d="M14 2V8H20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                                                <text x="6" y="17" font-size="5" fill="currentColor" font-weight="bold">XLS</text>
                                                                        </svg>
                                                                         <span>{{ $t('legacy.Смета Excel') }}</span>
                                                                        <svg v-if="!canExportExcel" class="lock-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <rect x="3" y="11" width="18" height="11" rx="2" stroke="currentColor" stroke-width="2"/>
                                                                                <path d="M7 11V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V11" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                                                                        </svg>
                                                                </div>
                                                                <div class="actions-menu-divider"></div>
                                                                <div 
                                                                        class="actions-menu-item ai-item" 
                                                                        :class="{ 'locked': !canUseAi }"
                                                                        @click="handleOpenAiModal"
                                                                         :title="!canUseAi ? $t('legacy.Доступно для премиум подписки с кредитами') : ''"
                                                                >
                                                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
                                                                                <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.5"/>
                                                                        </svg>
                                                                         <span>{{ $t('editor.aiProcessing') }}</span>
                                                                        <svg v-if="!canUseAi" class="lock-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <rect x="3" y="11" width="18" height="11" rx="2" stroke="currentColor" stroke-width="2"/>
                                                                                <path d="M7 11V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V11" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                                                                        </svg>
                                                                </div>
                                        </div>
                                </div>
                        </Teleport>

                        <!-- Выпадающий список фотозон (телепортируется в body для корректного z-index) -->
                        <Teleport to="body">
                                <div class="dropdown-wrapper" v-if="dropdownOpen" @click="closeDropdown">
                                        <div class="dropdown-content" @click.stop>
                                                <!-- Кнопка создания новой зоны -->
                                                <div class="dropdown-item create-zone-item" @click.stop="handleCreateZoneClick">
                                                        + {{ $t('legacy.Создать новую зону') }}
                                                </div>
                                                <!-- Список зон -->
                                                <div v-for="slide in slides" :key="slide.id" class="dropdown-item"
                                                        :class="{ 'is-active': activeSlideId === slide.id }" @click.stop="selectItem(slide.id)">
                                                        {{ slide.title }}
                                                </div>
                                        </div>
                                </div>
                        </Teleport>
                </div>

                <!-- Десктопная версия -->
                <div v-else class="desktop-slides-wrapper">
                        <!-- Стрелка влево (ВНЕ трека) -->
                        <button v-if="showLeftArrow" class="arrow left" @click="scrollLeft">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M15 18L9 12L15 6" stroke="#26374E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                        </button>


                        <!-- Трек фотозон -->
                        <div ref="track" class="slides-track" @scroll="checkArrows">
                                <!-- Кнопка "+" --> 
                                <div class="slide-item add-button" @click="openCreateModal">
                                        +
                                </div>

                                <!-- Фотозоны -->
                                <div v-for="(zone, index) in fotozones" :key="zone.id" class="slide-item" :class="{
                                        'is-active': activeSlideId === zone.id,
                                        'editing': editingId === zone.id
                                }" @click="handleSlideChange(zone.id)" draggable="true" @dragstart="dragStart($event, index)"
                                        @dragover.prevent="dragOver($event, index)" @drop.prevent="drop($event, index)" @dragend="dragEnd"
                                        @contextmenu="handleContextMenu($event, zone.id)"
                                        >

                                        <template v-if="editingId === zone.id">
                                                <input :ref="`editInput-${zone.id}`" v-model="editingTitle" @blur="finishEditing(zone.id)"
                                                        @keydown.enter="finishEditing(zone.id)" @keydown.esc="cancelEditing" maxlength="68" class="edit-input" />
                                        </template>
                                        <template v-else>
                                                <span class="slide-text" @click.stop="startEditing(zone.id)">{{ zone.title }}</span>
                                        </template>
                                </div>
                        </div>

                        <!-- Стрелка вправо (ВНЕ трека) -->
                        <button v-if="showRightArrow" class="arrow right" @click="scrollRight">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9 18L15 12L9 6" stroke="#26374E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                        </button>
                </div>

                <!-- Модальные окна (телепортируются в body для корректного z-index) -->
                <Teleport to="body">
                        <AppCreateFotozoneModal v-if="showCreateModal" :show="true" @close="closeCreateModal" @create="handleCreateZone"
                                :existing-titles="fotozones.map(z => z.title)" />
                </Teleport>
        </div>
</template>

<script>
import router from '@/router'
import { mapActions } from 'vuex'
import AppCreateFotozoneModal from './AppCreateFotozoneModal.vue'

export default {
        components: { AppCreateFotozoneModal },
        props: {
                activeSlideId: {
                        type: [Number, String],
                        required: true
                },
                highlight: {
                        type: Boolean,
                        default: false
                },
                slides: {
                        type: Array,
                        default: () => []
                },
                projectId: {
                        type: [Number, String],
                        default: null
                },
                canUndo: {
                        type: Boolean,
                        default: false
                },
                canRedo: {
                        type: Boolean,
                        default: false
                },
                layersPanelOpen: {
                        type: Boolean,
                        default: false
                },
                canUseCalculator: {
                        type: Boolean,
                        default: false
                }
        },
        data() {
                return {
                        touchTimer: null,
                        isTouching: false,
                        isMobile: window.innerWidth <= 1024,
                        dropdownOpen: false,
                        actionsMenuOpen: false,
                        showCreateModal: false,
                        showLeftArrow: false,
                        showRightArrow: false,
                        draggedIndex: null,
                        dragOverIndex: null,
                        isDragging: false,
                        dragStartX: 0,
                        scrollStartLeft: 0,
                        dragPosX: 0,
                        showContextMenu: false,
                        dragOffsetX: 0,
                        editingId: null,
                        editingTitle: '',
                        editInputElement: null,
                        originalOrder: [],
                        ghostElement: null,
                        dragStartIndex: null,
                        selectedZoneId: null,
                        contextMenuPosition: {
                                x: 0,
                                y: 0
                        },
                        // Добавляем внутреннее состояние для активного слайда
                        localActiveSlideId: null
                }
        },
        emits: ['slide-change', 'open-background', 'open-layers', 'toggle-layers', 'open-save', 'download-image', 'clear-all', 'toggle-selection', 'delete-zone', 'open-ai-modal', 'undo', 'redo', 'open-calculator'],
        computed: {
                fotozones() {
                        return this.slides || []
                },

                activeSlideTitle() {
                        const slide = this.fotozones.find(z => z.id === this.localActiveSlideId)
                        return slide ? slide.title : this.$t('legacy.Выберите фотозону')
                },

                canExportPdf() {
                        const value = this.$store.getters['subscription/canExportPdf']
                        console.log('🔒 canExportPdf computed:', value, 'subscription state:', this.$store.state.subscription)
                        return value
                },
                canExportExcel() {
                        const value = this.$store.getters['subscription/canExportExcel']
                        console.log('🔒 canExportExcel computed:', value)
                        return value
                },
                canUseAi() {
                        const isPaid = this.$store.getters['subscription/isPaid']
                        const credits = this.$store.getters['subscription/aiCredits']
                        return isPaid && credits > 0
                },

        },
        watch: {

                // Следим за изменением пропса activeSlideId
                activeSlideId: {
                        immediate: true,
                        handler(newActiveSlideId) {
                                if (newActiveSlideId && newActiveSlideId !== this.localActiveSlideId) {
                                        this.localActiveSlideId = newActiveSlideId

                                        // Прокручиваем к активной фотозоне
                                        this.$nextTick(() => {
                                                this.scrollToActiveSlide()
                                        })
                                }
                        }
                },

                // Следим за загрузкой фотозон
                fotozones: {
                        immediate: true,
                        handler() {
                                // Если у нас есть активный слайд из пропсов, но он еще не установлен локально
                                if (this.activeSlideId && !this.localActiveSlideId) {
                                        this.localActiveSlideId = this.activeSlideId

                                        // Прокручиваем к активной фотозоне после загрузки
                                        this.$nextTick(() => {
                                                this.scrollToActiveSlide()
                                        })
                                }
                        }
                }
        },
        methods: {
                ...mapActions('zones', ['createZone', 'updateZone', 'deleteZone']),

                handleMobileUndo() {
                        if (this.canUndo) {
                                this.$emit('undo')
                        }
                },
                handleMobileRedo() {
                        if (this.canRedo) {
                                this.$emit('redo')
                        }
                },

                handleTouchStart(event) {
                        this.isTouching = true;
                        this.touchTimer = setTimeout(() => {
                                if (this.isTouching) {
                                        console.log('123');
                                        this.handleContextMenu(event, this.localActiveSlideId);
                                }
                        }, 500); // 500 мс - время удержания
                },
                handleTouchEnd() {
                        this.isTouching = false;
                        if (this.touchTimer) {
                                clearTimeout(this.touchTimer);
                        }
                },
                contextMenuStyle() {
                        return {
        left: `${this.contextMenuPosition.x}px`,
        top: `${this.contextMenuPosition.y}px`,
      }
                },
                async handleDeleteSlide() {
                        try {
                                await this.deleteZone(this.selectedZoneId);
                                
                                if (this.fotozones.length < 1) {
                                        router.push('/projects')
                                }
                        } catch (error) {
                                console.error('Ошибка удаления зоны:', error)
                                alert(this.$t('Не удалось удалить зону.'))
                        }
                        
                        this.showContextMenu = false
                },
                handleContextMenu(event, zoneId) {
                        event.preventDefault();
                        this.showContextMenu = true;
                        this.contextMenuPosition.x = event.clientX;
                        this.contextMenuPosition.y = event.clientY;
                        this.selectedZoneId = zoneId;
                },
                handleSlideChange(id) {
                        if (this.localActiveSlideId !== id) {
                                this.localActiveSlideId = id
                                this.$emit('slide-change', id)
                        }
                        this.dropdownOpen = false
                },

                // Прокрутка к активной фотозоне
                scrollToActiveSlide() {
                        if (!this.localActiveSlideId || !this.$refs.track) return

                        const activeElement = this.$el.querySelector(`.slide-item.is-active`)
                        if (!activeElement) return

                        const track = this.$refs.track
                        const trackRect = track.getBoundingClientRect()
                        const elementRect = activeElement.getBoundingClientRect()

                        // Вычисляем позицию для прокрутки
                        const scrollPosition = elementRect.left - trackRect.left + track.scrollLeft - (trackRect.width / 2) + (elementRect.width / 2)

                        // Плавная прокрутка
                        track.scrollTo({
                                left: scrollPosition,
                                behavior: 'smooth'
                        })

                        this.checkArrows()
                },

                selectItem(id) {
                        this.handleSlideChange(id)
                        this.dropdownOpen = false
                },
                setEditInputRef(el) {
                        this.editInputElement = el
                },
                startEditing(id) {
                        const zone = this.fotozones.find(z => z.id === id)
                        if (!zone) return
                        this.editingId = id
                        this.editingTitle = zone.title
                        this.originalTitle = zone.title
                        this.$nextTick(() => {
                                const inputRef = this.$refs[`editInput-${id}`]
                                const inputElement = Array.isArray(inputRef) ? inputRef[0] : inputRef
                                if (inputElement) {
                                        inputElement.focus()
                                        inputElement.select()
                                }
                        })
                },

                async finishEditing(id) {
                        if (!this.editingTitle.trim()) {
                                this.editingTitle = this.originalTitle
                                this.cancelEditing()
                                return
                        }

                        const trimmedTitle = this.editingTitle.trim()

                        const duplicate = this.fotozones.some(
                                zone => zone.id !== id && zone.title.toLowerCase() === trimmedTitle.toLowerCase()
                        )

                        if (duplicate) {
                                this.editingTitle = this.originalTitle
                                alert(this.$t('Название уже используется. Пожалуйста, выберите другое название.'))
                                this.$nextTick(() => {
                                        const inputRef = this.$refs[`editInput-${id}`]
                                        const inputElement = Array.isArray(inputRef) ? inputRef[0] : inputRef
                                        if (inputElement) {
                                                inputElement.focus()
                                                inputElement.select()
                                        }
                                })
                                return
                        }

                        try {
                                const zone = this.fotozones.find(z => z.id === id)
                                if (zone) {
                                        await this.updateZone({ 
                                                zoneId: id, 
                                                title: trimmedTitle 
                                        });
                                }
                        } catch (error) {
                                console.error('Ошибка обновления названия зоны:', error)
                                alert(this.$t('Не удалось обновить название зоны.'))
                        }

                        this.editingId = null
                        this.editingTitle = ''
                        this.originalTitle = ''
                        this.editInputElement = null
                },

                cancelEditing() {
                        this.editingId = null
                        this.editingTitle = ''
                        this.originalTitle = ''
                        this.editInputElement = null
                },
                smoothScrollBy(distance) {
                        const track = this.$refs.track
                        if (!track) return

                        const start = track.scrollLeft
                        const end = start + distance
                        const duration = 300 // длительность анимации в мс
                        const startTime = performance.now()

                        const animate = (time) => {
                                const elapsed = time - startTime
                                const progress = Math.min(elapsed / duration, 1)
                                // easeInOutQuad
                                const ease = progress < 0.5
                                        ? 2 * progress * progress
                                        : -1 + (4 - 2 * progress) * progress

                                track.scrollLeft = start + (end - start) * ease

                                if (progress < 1) {
                                        requestAnimationFrame(animate)
                                } else {
                                        this.checkArrows()
                                }
                        }

                        requestAnimationFrame(animate)
                },

                scrollLeft() {
                        this.smoothScrollBy(-200)
                },

                scrollRight() {
                        this.smoothScrollBy(200)
                },
                openCreateModal() {
                        this.showCreateModal = true
                        this.$emit('modal-opened', true)
                },
                closeCreateModal() {
                        this.showCreateModal = false
                        this.$emit('modal-opened', false)
                },
                checkArrows() {
                        const el = this.$refs.track
                        if (!el) {
                                this.showLeftArrow = false
                                this.showRightArrow = false
                                return
                        }
                        this.showLeftArrow = el.scrollLeft > 0
                        this.showRightArrow = el.scrollLeft + el.clientWidth < el.scrollWidth - 1
                },
                toggleDropdown() {
                        this.dropdownOpen = !this.dropdownOpen
                        this.actionsMenuOpen = false
                },
                closeDropdown() {
                        this.dropdownOpen = false
                },
                toggleActionsMenu() {
                        this.actionsMenuOpen = !this.actionsMenuOpen
                        this.dropdownOpen = false
                },
                closeActionsMenu() {
                        this.actionsMenuOpen = false
                },
                handleToggleSelection() {
                        this.actionsMenuOpen = false
                        this.$emit('toggle-selection')
                },
                handleOpenBackground() {
                        this.actionsMenuOpen = false
                        this.$emit('open-background')
                },
                handleOpenLayers() {
                        this.actionsMenuOpen = false
                        this.$emit('open-layers')
                },
                handleToggleLayers() {
                        this.$emit('toggle-layers')
                },
                handleOpenCalculator() {
                        this.$emit('open-calculator')
                },
                handleOpenSave() {
                        this.actionsMenuOpen = false
                        this.$emit('open-save')
                },
                handleDownloadImage() {
                        this.actionsMenuOpen = false
                        this.$emit('download-image')
                },
                handleClearAll() {
                        this.actionsMenuOpen = false
                        this.$emit('clear-all')
                },
                handleDeleteZone() {
                        this.actionsMenuOpen = false
                        this.$emit('delete-zone')
                },
                async handleExportPDF() {
                        this.actionsMenuOpen = false
                        if (!this.canExportPdf) {
                                this.$router.push('/subscription/plans')
                                return
                        }
                        try {
                                const projectName = this.$store.state.projects.currentProject?.name || this.$t('estimate.project')
                                const { exportToPDF } = await import('@/utils/estimateExport.js')
                                await exportToPDF(this.$store, projectName)
                        } catch (error) {
                                console.error('Ошибка экспорта PDF:', error)
                                alert(this.$t('Не удалось экспортировать смету в PDF'))
                        }
                },
                async handleExportExcel() {
                        this.actionsMenuOpen = false
                        if (!this.canExportExcel) {
                                this.$router.push('/subscription/plans')
                                return
                        }
                        try {
                                const projectName = this.$store.state.projects.currentProject?.name || this.$t('estimate.project')
                                const { exportToExcel } = await import('@/utils/estimateExport.js')
                                exportToExcel(this.$store, projectName)
                        } catch (error) {
                                console.error('Ошибка экспорта Excel:', error)
                                alert(this.$t('Не удалось экспортировать смету в Excel'))
                        }
                },
                handleOpenAiModal() {
                        this.actionsMenuOpen = false
                        if (!this.canUseAi) {
                                this.$router.push('/subscription/plans')
                                return
                        }
                        this.$emit('open-ai-modal')
                },
                handleCreateZoneClick() {
                        this.dropdownOpen = false
                        this.openCreateModal()
                },
                handleClickOutsidePanel(event) {
                        if (!event.target.closest('.slide-item') && !event.target.closest('.context-menu')) {
                                this.showContextMenu = false;
                        }
                },
                checkMobile() {
                        this.isMobile = window.innerWidth <= 1024
                },
                async handleCreateZone(newTitle) {
                        const trimmedTitle = newTitle.trim()
                        
                        if (!this.projectId) {
                                console.error('projectId is required to create a zone')
                                alert(this.$t('editor.missingProjectId'))
                                return
                        }

                        try {
                                const response = await this.createZone({ 
                                        projectId: this.projectId, 
                                        title: trimmedTitle 
                                });
                                
                                this.showCreateModal = false
                                
                                if (response && response.id) {
                                        this.handleSlideChange(response.id)
                                }
                        } catch (error) {
                                console.error('Ошибка создания зоны:', error)
                                alert(this.$t('Не удалось создать зону.'))
                        }
                },
                handleDeleteAllZones() {
                        console.warn('handleDeleteAllZones not implemented for zones architecture')
                        this.showCreateModal = false
                        router.push('/projects')
                },

                // --- Drag & Drop методы ---
                dragStart(event, index) {
                        this.draggedIndex = index
                        this.isDraggingCustom = true

                        // Сохраняем начальные данные
                        this.dragStartX = event.clientX
                        this.dragStartIndex = index
                        this.originalOrder = [...this.fotozones]

                        // Добавляем класс dragging
                        event.target.classList.add('dragging')

                        // Создаем ghost элемент
                        this.createGhostElement(event.target)

                        event.dataTransfer.setDragImage(new Image(), 0, 0)
                },

                dragMove(event) {
                        if (!this.isDraggingCustom) return

                        const deltaX = event.clientX - this.dragStartX
                        this.dragPosX = event.clientX

                        // Плавное перемещение dragging элемента
                        const draggingElement = this.$el.querySelector('.slide-item.dragging')
                        if (draggingElement) {
                                draggingElement.style.transform = `translateX(${deltaX}px) scale(1.05) rotate(5deg)`
                        }

                        // Определяем новый индекс на основе позиции
                        this.updateDragPosition(event.clientX)
                },

                dragOver(event, index) {
                        if (!this.isDraggingCustom) return
                        event.preventDefault()

                        this.dragOverIndex = index
                        this.updateDropIndicator(index)
                },

                drop(event, index) {
                        if (this.draggedIndex === null) return

                        // Убираем все классы анимации
                        this.clearDragStyles()

                        // Выполняем перемещение
                        if (this.draggedIndex !== index) {
                                this.smoothReorder(this.draggedIndex, index)
                        }

                        this.draggedIndex = null
                        this.dragOverIndex = null
                        this.isDraggingCustom = false
                },

                // eslint-disable-next-line no-unused-vars
                dragEnd(event) {
                        this.clearDragStyles()
                        this.draggedIndex = null
                        this.dragOverIndex = null
                        this.isDraggingCustom = false
                },

                // Вспомогательные методы
                createGhostElement(element) {
                        // Создаем полупрозрачную копию для визуального эффекта
                        const rect = element.getBoundingClientRect()
                        const ghost = element.cloneNode(true)
                        ghost.classList.add('drag-ghost')
                        ghost.style.position = 'fixed'
                        ghost.style.left = `${rect.left}px`
                        ghost.style.top = `${rect.top}px`
                        ghost.style.width = `${rect.width}px`
                        ghost.style.pointerEvents = 'none'
                        ghost.style.zIndex = '1000'

                        document.body.appendChild(ghost)
                        this.ghostElement = ghost
                },

                updateDragPosition(clientX) {
                        const track = this.$refs.track
                        if (!track) return

                        const trackRect = track.getBoundingClientRect()
                        const items = track.querySelectorAll('.slide-item:not(.dragging)')

                        // Определяем позицию относительно трека
                        const relativeX = clientX - trackRect.left

                        let newIndex = this.draggedIndex

                        // Определяем новый индекс на основе позиции
                        items.forEach((item, index) => {
                                const itemRect = item.getBoundingClientRect()
                                const itemCenter = itemRect.left + itemRect.width / 2 - trackRect.left

                                if (relativeX > itemCenter) {
                                        newIndex = index + (index >= this.draggedIndex ? 1 : 0)
                                }
                        })

                        newIndex = Math.max(0, Math.min(newIndex, items.length))

                        // Плавно сдвигаем элементы
                        if (newIndex !== this.dragOverIndex) {
                                this.dragOverIndex = newIndex
                                this.updateDropIndicator(newIndex)
                        }
                },

                updateDropIndicator(index) {
                        // Убираем старый индикатор
                        const oldIndicator = this.$el.querySelector('.drop-indicator')
                        if (oldIndicator) oldIndicator.remove()

                        const items = this.$el.querySelectorAll('.slide-item:not(.dragging)')
                        if (items.length === 0 || index > items.length) return

                        // Создаем новый индикатор
                        const indicator = document.createElement('div')
                        indicator.className = 'drop-indicator'

                        if (index === items.length) {
                                // Вставка в конец
                                const lastItem = items[items.length - 1]
                                const lastRect = lastItem.getBoundingClientRect()
                                const trackRect = this.$refs.track.getBoundingClientRect()

                                indicator.style.left = `${lastRect.right - trackRect.left + 6}px`
                        } else {
                                // Вставка между элементами
                                const targetItem = items[index]
                                const targetRect = targetItem.getBoundingClientRect()
                                const trackRect = this.$refs.track.getBoundingClientRect()

                                indicator.style.left = `${targetRect.left - trackRect.left - 3}px`
                        }

                        this.$refs.track.appendChild(indicator)
                },

                clearDragStyles() {
                        // Убираем все классы и стили
                        const items = this.$el.querySelectorAll('.slide-item')
                        items.forEach(item => {
                                item.classList.remove('dragging', 'drag-ghost', 'drag-target')
                                item.style.transform = ''
                        })

                        // Убираем индикатор
                        const indicator = this.$el.querySelector('.drop-indicator')
                        if (indicator) indicator.remove()

                        // Убираем ghost элемент
                        if (this.ghostElement) {
                                this.ghostElement.remove()
                                this.ghostElement = null
                        }
                },

                smoothReorder(fromIndex, toIndex) {
                        if (fromIndex === toIndex) return
                        
                        console.log('Zone reordering - not persisted to backend')
                        
                        setTimeout(() => this.checkArrows(), 300)
                },
        },
        mounted() {
                this.checkMobile()

                this.$nextTick(() => this.checkArrows())
                window.addEventListener('resize', this.checkMobile)
                window.addEventListener('resize', this.checkArrows)
                document.addEventListener('click', this.handleClickOutsidePanel)
        },
        beforeUnmount() {
                window.removeEventListener('resize', this.checkMobile)
                window.removeEventListener('resize', this.checkArrows)
                document.removeEventListener('click', this.handleClickOutsidePanel)
        },
        updated() {
                this.$nextTick(() => this.checkArrows())
        }
}
</script>

<style scoped>
.context-menu {
        position: fixed;
        z-index: 9999;
}
.context-menu__button {
        cursor: pointer;
        display: block;
        appearance: none;
        border: 0;
        padding: 10px 15px;
        margin: 0;
        width: 100%;
        border: 1px solid #f6f2ef;
        border-radius: 5px;
        background: #fff;
        width: auto;
        padding: 10px 30px;
        text-align: left;
        font-size: 14px;
  font-weight: 700;
  color: #26374E;
}
.context-menu__button:hover {
        background-color: #eaedf0;
}
.slide-item.editing {
        min-width: 140px;
        background: #ffffff !important;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
        border: 2px solid #E0E4E8 !important;
}

.edit-input {
        width: 100%;
        max-width: 160px;
        box-sizing: border-box;
        font-size: 13px;
        font-weight: 600;
        text-align: center;
        border: none;
        background: transparent;
        outline: none;
        color: #26374E;
        padding: 0;
        user-select: text;
        font-family: inherit;
        text-transform: uppercase;
        letter-spacing: 0.5px;
}

.slide-text,
.edit-input {
        font-size: 13px;
        font-weight: 600;
        color: #26374E;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        font-family: inherit;
}

/* Стрелки */
.arrow {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        background: #ffffff;
        border: none;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        width: 40px;
        height: 40px;
        border-radius: 50%;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: transform 0.2s ease, background-color 0.3s ease;
        z-index: 2;
}

.arrow svg {
        pointer-events: none;
}

.arrow.left {
        left: 8px;
}

.arrow.right {
        right: 8px;
}

.slides-container {
        position: relative;
}

.guide-highlight {
        position: relative;
}

.guide-highlight::before {
        content: '';
        position: absolute;
        top: -10px;
        left: -10px;
        right: -10px;
        bottom: -10px;
        border: 3px dashed #4a90e2;
        border-radius: 12px;
        animation: pulse-border 2s infinite;
        pointer-events: none;
        z-index: 1;
}

@keyframes pulse-border {
        0% {
                opacity: 0.7;
                transform: scale(1);
        }

        50% {
                opacity: 0.3;
                transform: scale(1.02);
        }

        100% {
                opacity: 0.7;
                transform: scale(1);
        }
}

/* Мобильные стили */
.mobile-slide {
        position: relative;
        width: 100%;
        margin-bottom: 8px;
}

.mobile-slide-content {
        position: relative;
        background: rgba(255, 255, 255, 0.95);
        border-radius: 12px;
        box-shadow: 2px 6px 20px rgba(0, 0, 0, 0.15);
        padding: 12px 60px;
        height: 56px;
        display: flex;
        align-items: center;
        justify-content: center;
}

.mobile-nav-arrow {
        position: absolute;
        left: 16px;
        top: 50%;
        transform: translateY(-50%);
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background-color: #FAFAFA;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        z-index: 2;
}

.mobile-nav-arrow svg {
        width: 16px;
        height: 16px;
}

/* Кнопки Undo/Redo для мобильной версии */
.mobile-history-btn {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background-color: #FAFAFA;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        border: none;
        color: #26374E;
        transition: all 0.2s;
        margin: 0 4px;
}

.mobile-history-btn:hover:not(.disabled) {
        background-color: #F0F4F8;
}

.mobile-history-btn.disabled {
        opacity: 0.4;
        cursor: not-allowed;
}

.mobile-history-btn svg {
        width: 18px;
        height: 18px;
}

/* Иконка выбора зоны */
.mobile-zone-selector {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background-color: #FAFAFA;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        border: none;
        color: #26374E;
        transition: all 0.2s;
        margin: 0 8px;
}

.mobile-zone-selector:hover {
        background-color: #F0F4F8;
}

.mobile-zone-selector svg {
        width: 20px;
        height: 20px;
}

.mobile-layers-btn {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background-color: #FAFAFA;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        border: none;
        color: #26374E;
        transition: all 0.2s;
        margin: 0 4px;
}

.mobile-layers-btn:hover {
        background-color: #F0F4F8;
}

.mobile-layers-btn.active {
        background-color: #4A90D9;
        color: #fff;
}

.mobile-layers-btn svg {
        width: 18px;
        height: 18px;
}

.mobile-calculator-btn {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background: linear-gradient(135deg, #BBCAD8 0%, #496782 100%);
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        border: none;
        color: #fff;
        transition: all 0.2s;
        margin: 0 4px;
}

.mobile-calculator-btn:hover {
        transform: scale(1.05);
        box-shadow: 0 4px 12px rgba(73, 103, 130, 0.4);
}

.mobile-calculator-btn svg {
        width: 18px;
        height: 18px;
}

.slide-text {
        font-size: 14px;
        font-weight: 700;
        color: #26374E;
        text-transform: uppercase;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        text-align: center;
        cursor: pointer;
        letter-spacing: 0.5px;
}

/* Кнопка с тремя точками */
.mobile-menu-dots {
        position: absolute;
        right: 16px;
        top: 50%;
        transform: translateY(-50%);
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background-color: #FAFAFA;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        z-index: 2;
        transition: background-color 0.2s;
}

.mobile-menu-dots:hover {
        background-color: #F0F4F8;
}

.menu-dots {
        display: flex;
        flex-direction: row;
        gap: 3px;
        align-items: center;
}

.menu-dots span {
        display: block;
        width: 4px;
        height: 4px;
        background-color: #666;
        border-radius: 50%;
}

/* Выпадающее меню действий */
.actions-menu-wrapper {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        z-index: 10000;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        padding-top: 80px;
}

.actions-menu-content {
        background: white;
        border-radius: 12px;
        box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
        width: calc(100% - 32px);
        max-width: 400px;
        overflow: hidden;
}

.actions-menu-item {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 14px 16px;
        font-size: 14px;
        font-weight: 400;
        color: #26374E;
        cursor: pointer;
        transition: background-color 0.2s;
        text-align: left;
        border-bottom: 1px solid #f0f0f0;
}

.actions-menu-item svg {
        flex-shrink: 0;
}

.actions-menu-item span {
        flex: 1;
}

.actions-menu-item:last-child {
        border-bottom: none;
}

.actions-menu-item:hover:not(.disabled) {
        background-color: #f5f7fa;
}

.actions-menu-item.active {
        color: #007bff;
        font-weight: 700;
}

.actions-menu-item.disabled {
        color: #999;
        cursor: not-allowed;
        opacity: 0.5;
        justify-content: center;
}

.actions-menu-item.download-item {
        color: #4a90e2;
}

.actions-menu-item.download-item:hover {
        background-color: #e8f4fc;
}

.actions-menu-item.delete-item {
        color: #e74c3c;
}

.actions-menu-item.delete-item:hover {
        background-color: #fce8e8;
}

.actions-menu-item.ai-item {
        color: #9b59b6;
}

.actions-menu-item.ai-item:hover {
        background-color: #f5eef8;
}

.actions-menu-item.locked {
        color: #999;
        cursor: pointer;
}

.actions-menu-item.locked:hover {
        background-color: #f5f5f5;
}

.actions-menu-item .lock-icon {
        color: #999;
        margin-left: auto;
        flex-shrink: 0;
}

.actions-menu-divider {
        height: 1px;
        background: #e8e8e8;
        margin: 0;
}

/* Выпадающий список */
.dropdown-wrapper {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        z-index: 10000;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        padding-top: 80px;
}

.dropdown-content {
        background: white;
        border-radius: 12px;
        box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
        width: calc(100% - 32px);
        max-width: 400px;
        max-height: 70vh;
        overflow-y: auto;
}

.dropdown-item {
        padding: 16px;
        font-size: 14px;
        font-weight: 400;
        color: #26374E;
        text-transform: uppercase;
        cursor: pointer;
        transition: background-color 0.2s;
        text-align: center;
        border-bottom: 1px solid #f0f0f0;
}

.dropdown-item:last-child {
        border-bottom: none;
}

.dropdown-item:hover,
.dropdown-item.is-active {
        background-color: #f8f8f8;
}

.dropdown-item.create-zone-item {
        color: #007bff;
        font-weight: 700;
        background-color: #f0f8ff;
}

.dropdown-item.create-zone-item:hover {
        background-color: #e6f2ff;
}

/* Десктопные стили (из вашего кода) */
.slides-track {
        display: flex;
        gap: 12px;
        overflow-x: auto;
        justify-content: flex-start;
        scrollbar-width: none;
        transition: all 0.3s ease;
}

.slides-track::-webkit-scrollbar {
        display: none;
}

.slide-item {
        flex: 0 0 auto;
        max-width: 180px;
        min-width: 120px;
        padding: 10px 16px;
        font-size: 13px;
        white-space: nowrap;
        border-radius: 12px 12px 0 0;
        transition: all 0.3s ease;
        background: #E0E4E8;
        color: #26374E;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        cursor: pointer;
        text-align: center;
        user-select: none;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94),
                transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94),
                box-shadow 0.3s ease;
}

.slide-item.drag-ghost {
        opacity: 0.4;
        transform: scale(0.95);
}

.slide-item.drag-target {
        transform: translateX(var(--drag-offset, 0px));
        transition: transform 0.2s ease;
}

.drop-indicator {
        position: absolute;
        top: 50%;
        width: 4px;
        height: 60%;
        background: #3b82f6;
        border-radius: 2px;
        transform: translateY(-50%);
        z-index: 50;
        animation: drop-pulse 1s infinite;
}



.slide-item:not(.dragging) {
        transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

/* Плавное появление/исчезновение индикатора */
.slide-item.drop-target::after {
        transition: opacity 0.3s ease, transform 0.3s ease;
}

/* Эффект наведения при перетаскивании */
.slides-track:has(.dragging) .slide-item:not(.dragging):hover {
        transform: translateX(0) scale(1.02);
}

.slide-item.dragging {
        opacity: 0.5;
        transform: scale(0.95);
        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
}

.slide-item.drag-over {
        transform: scale(1.05);
        background: #d5dce3 !important;
}

.slide-item.drop-target {
        position: relative;
}

.slide-item.drop-target::after {
        content: '';
        position: absolute;
        top: 50%;
        left: -6px;
        transform: translateY(-50%);
        width: 4px;
        height: 80%;
        background: #3b82f6;
        border-radius: 2px;
        animation: drop-target-pulse 1s infinite;
}

@keyframes drop-target-pulse {

        0%,
        100% {
                opacity: 0.7;
                transform: translateY(-50%) scale(1);
        }

        50% {
                opacity: 1;
                transform: translateY(-50%) scale(1.1);
        }
}

.slide-item.is-active {
        background: #ffffff;
        color: #26374E;
        border: none;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.add-button {
        background-color: #E0E4E8;
        color: #26374E;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 12px 12px 0 0;
        width: 48px;
        height: 38px;
        min-width: unset;
        max-width: unset;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
        transition: background-color 0.3s ease, transform 0.2s ease;
}

.add-button:hover {
        background-color: #f0f4f8;
        transform: scale(1.05);
}

.edit-input {
        width: 100%;
        max-width: 180px;
        box-sizing: border-box;
        font-size: 15px;
        font-weight: 600;
        text-align: center;
        border: none;
        background: transparent;
        outline: none;
        color: inherit;
        padding: 0;
        user-select: text;
}

/* Адаптация */
@media (min-width: 1024px) {
        .mobile-slide {
                display: none;
        }
}

@media (max-width: 1023px) {
        .slides-track {
                display: none;
        }
}
</style>
